import { BehaviorSubject } from "rxjs";
import { ContentForm } from "src/app/secure/content/impl/content-form";
import { v4 as uuidv4 } from "uuid";
import { TableField } from "./table-field";

export class TableRow {
  public id: string;
  public deletelink: string;
  public downloadlink: string;
  public fields: TableField[];
  public hidden: boolean;
  public deleted: boolean;
  public selected: boolean;
  public highlighted: boolean;
  public loaded: boolean;

  public form: BehaviorSubject<ContentForm | null>;

  public constructor() {
    this.id = uuidv4();
    this.fields = [];
    this.deletelink = "";
    this.downloadlink = "";

    this.hidden = false;
    this.deleted = false;
    this.selected = false;
    this.highlighted = false;
    this.loaded = false;
    this.form = new BehaviorSubject<ContentForm | null>(null);
  }

  public delete(_delete = true): void {
    this.deleted = _delete;
  }

  public hide(hide = true): void {
    this.hidden = hide;
  }

  public select(select = true): void {
    this.selected = select;
  }

  public highlight(highlight = true): void {
    this.highlighted = highlight;
  }
}
